import React from 'react';

interface InputBoxProps {
    label?: string;
    children?: React.ReactNode;
    className?: string;
    required?: boolean;
    comment?: string;
}

const InputBox = React.forwardRef<HTMLDivElement, InputBoxProps>(function (props, ref) {
    const labelRef = React.useRef<HTMLLabelElement>(null);
    const { 0: label, 1: setLabel } = React.useState('');
    const { 0: labelWidth, 1: setLabelWidth } = React.useState(0);
    React.useEffect(() => {
        setLabel(props.label || '');
    }, [props.label]);
    React.useEffect(() => {
        labelRef.current?.dispatchEvent(new Event('calc'));
    }, [label]);
    React.useEffect(() => {
        let l = () => {
            setLabelWidth((labelRef.current?.clientWidth || 0) * 0.8 + 8);
        };
        labelRef.current?.addEventListener('calc', l);
        return () => {
            labelRef.current?.removeEventListener('calc', l);
        };
    }, []);
    return (
        <div className={"form-outline form-input " + (props.className || '') + (props.required ? ' required' : '') + (props.comment ? ' comment' : '')} ref={ref}>
            {props.children}
            <label className="form-label" ref={labelRef}>{label}</label>
            <div className="form-notch">
                <div className="form-notch-leading"></div>
                <div className="form-notch-middle" style={{ width: labelWidth + "px" }}></div>
                <div className="form-notch-trailing"></div>
            </div>
        </div>
    );
});

export default InputBox;